import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import PermissionsServices from "../services/Permissions.Service";
export const getPermissions = createAsyncThunk("permission/list", async () => {
  const response = await PermissionsServices.loadPermissions();
  return response;
});

export const savePermission = createAsyncThunk(
  "permission/save",
  async (formData, thunkAPI) => {
    try{
      const response = await PermissionsServices.savePermission(formData);
      return response;
    }catch(exception){
      if (!exception.response) {
        return exception
      }
      return thunkAPI.rejectWithValue(exception?.response?.data)
    }
    
  }
);

export const loadRoles = createAsyncThunk("roles", async (params, thunkAPI)=>{
  try{
      let {data} = params
      let pageData =  Object.assign({}, data)
      // if(pageData.page){
      //     pageData.page = pageData.page - 1  
      // }
      const response = await PermissionsServices.loadRoles(pageData);
      return response;
  }catch(exception){
      if (!exception.response) {
        return exception
      }
      return thunkAPI.rejectWithValue(exception?.response?.data)
  }

});

export const loadRole = createAsyncThunk("role", async (id, thunkAPI)=>{
  try{
      
      const response = await PermissionsServices.loadRole(id);
      return response;
  }catch(exception){
      if (!exception.response) {
        return exception
      }
      return thunkAPI.rejectWithValue(exception?.response?.data)
  }
});

export const allActiveRoles = createAsyncThunk("allActiveRoles", async (thunkAPI)=>{
  try{
      
      const response = await PermissionsServices.allActiveRoles();
      return response;
  }catch(exception){
      if (!exception.response) {
        return exception
      }
      return thunkAPI.rejectWithValue(exception?.response?.data)
  }

});

const initialState = {
  list: [],
  userRoleData: [],
  totalCount:0,
  success: '',
  error: '',
  loading: false,
  message: "",
  roleData:{},
  roleList:[]
}
const PermissionsSlices = createSlice({
  name: "Permissions",
  initialState,
  reducers: {
    test: () => {
      console.log("sdsdfsf");
    },
    reset:() => initialState,
  },
  extraReducers: {
    [getPermissions.pending]: (state) => {
      state.loading = true;
      state.error = false;
      state.success = false;
    },
    [getPermissions.fulfilled]: (state, action) => {
      state.loading = false;
      state.list = action.payload;
    },
    [getPermissions.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
    },
    //save permission
    [savePermission.pending]: (state) => {
      state.loading = true;
      state.success = false;
      state.error = false;
    },
    [savePermission.fulfilled]: (state, action) => {
      state.loading = false;
      state.success = action.payload.msg;
      state.roleData = action.payload.doc
    },
    [loadRoles.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload.success;
      //k,nbbghjukklstate.message = action.
    },
    [loadRoles.pending]: (state) => {
      state.loading = true;
      state.error = false;
      state.success = false;
    },
    [loadRoles.fulfilled]: (state, action) => {
      state.loading = false;
      state.userRoleData = action.payload.docs;
      state.totalCount = action.payload.totalDocs
    },
    // Load Role
    [loadRole.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload.success;
    },
    [loadRole.pending]: (state) => {
      state.loading = true;
      state.error = false;
      state.success = false;
    },
    [loadRole.fulfilled]: (state, action) => {
      state.loading = false;
      state.roleData = action.payload;
    },
    //Load All Active Role
    [allActiveRoles.rejected] : (state, action) => {
      state.loading = false;
      state.error = action.payload.errors.msg;
    },
    [allActiveRoles.pending]: (state) => {
      state.loading = true;
      state.error = false;
      state.success = false;
    },
    [allActiveRoles.fulfilled]: (state, action) => {
      state.loading = false;
      state.roleList = action.payload.docs;
    },
  },
});

export const { test, reset } = PermissionsSlices.actions;
export default PermissionsSlices.reducer;
